export default "__VITE_ASSET__DKznaDr9__"